import { Action } from "redux";
import { ChallengeResult } from "./challenge";
import { ThunkDispatch } from ".";
import { TransactionMedium } from "../types/transaction";
import { analyze } from "./api";

// Types

interface PayeesState {
  list: Payee[]
}

export interface Payee {
  medium: TransactionMedium
  accountNumber: string
  accountNickName: string
  routingCode: string,
}

// Initialization

const initialState: PayeesState = {
  list: [
    {
      medium: TransactionMedium.Wire,
      accountNumber: "0000312813949",
      accountNickName: "John Dennis",
      routingCode: "021000021",
    },
    {
      medium: TransactionMedium.Wire,
      accountNumber: "0000345177125",
      accountNickName: "Stephanie Vickery",
      routingCode: "011401533",
    },
    {
      medium: TransactionMedium.BillpayElectronic,
      accountNumber: "8001",
      accountNickName: "Car Insurance Provider",
      routingCode: "011401533",
    },
    {
      medium: TransactionMedium.BillpayElectronic,
      accountNumber: "1001432108882",
      accountNickName: "Electricity",
      routingCode: "091000019",
    },
    {
      medium: TransactionMedium.BillpayElectronic,
      accountNumber: "7509834175224",
      accountNickName: "Gas Provider",
      routingCode: "091000019",
    },
    {
      medium: TransactionMedium.BillpayElectronic,
      accountNumber: "3957661823557",
      accountNickName: "Internet Service Provider",
      routingCode: "021000021",
    },
  ]
}

// Action Definition

export const PAYEES_RESET = 'payees/PAYEE_RESET'
export const PAYEES_ADD = 'payees/PAYEE_ADD'
export const PAYEES_REMOVE = 'payees/PAYEE_REMOVE'

interface PayeesResetAction extends Action {
  type: typeof PAYEES_RESET,
  userName: string
}

interface PayeesAddAction extends Action {
  type: typeof PAYEES_ADD,
  payee: Payee
}

interface PayeesRemoveAction extends Action {
  type: typeof PAYEES_REMOVE,
  payee: Payee
}


export default (state = initialState, action: Action) => {
  switch (action.type) {
    case PAYEES_RESET:
      return {
        ...initialState,
      }

    case PAYEES_ADD:
      return {
        ...state,
        list: [...state.list, (action as PayeesAddAction).payee]
      }

    case PAYEES_REMOVE:
      return {
        ...state,
        list: state.list.filter(a => a !== (action as PayeesAddAction).payee)
      }

    default:
      return state
  }
}

export const reset = () =>
  ({
    type: PAYEES_RESET,
  });

export const add = (payee: Payee) =>
  (dispatch: ThunkDispatch) => {
    let { analyzePromise, challengePromise } = dispatch(analyze({
      eventDataList: {
        eventData: {
          eventType: "ADD_PAYEE",
          transactionData: {
            otherAccountType: payee.medium === TransactionMedium.BillpayElectronic ? "BILLER" : "PERSONAL_ACCOUNT",
            otherAccountBankType: "OTHER_BANK",
            transferMediumType: payee.medium,
            otherAccountOwnershipType: "ME_TO_YOU",
            otherAccountData: {
              accountNickName: payee.accountNickName,
              accountNumber: payee.accountNumber,
              routingCode: payee.routingCode,
            }
          }
        },
      }
    }))

    challengePromise.then(result => {
      if(result === ChallengeResult.None || result === ChallengeResult.Success) {
        dispatch({
          type: PAYEES_ADD,
          payee
        } as PayeesAddAction)
      }
      return result
    })

    return {analyzePromise, challengePromise}
  }

export const remove = (payee: Payee) =>
  ({
    type: PAYEES_REMOVE,
    payee
  }) as PayeesRemoveAction